import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { ITaskInfo, IVehicleAddress } from '../../interfaces/task-info';
import { TaskSupplierScheduleStore } from '../task-supplier-schedule/task-supplier-schedule-store';
import { observable, computed } from 'mobx-angular';
import { OrganisationTypeEnum } from '../../enums/organisation-types';
import { JobsService } from '../../services';

enum DateTimeColumnType {
  PickUp = 0,
  DropOff = 1,
}

interface DateTimeColumn {
  title: string;
  date: Date;
  type: DateTimeColumnType;
  iconClass: string;
}

@Component({
  templateUrl: './display-route-simple.component.html',
  selector: 'display-route-simple',
  styleUrls: ['./display-route-simple.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DisplayRouteSimpleComponent implements OnInit, OnChanges {
  @Input() @observable public task: ITaskInfo;
  @Input() @observable public orgTypeId: number;

  @computed public get pickupLocation(): IVehicleAddress {
    return this.task.pickupLocation;
  }

  @computed public get dropoffLocation(): IVehicleAddress {
    return this.task.dropoffLocation;
  }

  @computed public get pickupEarliestDateTime(): Date {
    return this.task.pickupEarliestDateTime;
  }

  @computed public get pickupLatestDateTime(): Date {
    return this.task.pickupLatestDateTime;
  }

  @computed public get dropoffEarliestDateTime(): Date {
    return this.task.dropoffEarliestDateTime;
  }

  @computed public get dropoffLatestDateTime(): Date {
    return this.task.dropoffLatestDateTime;
  }

  // Original task dates/times for rescheduled task
  @computed public get originalPickupEarliestDateTime(): Date {
    return this.task.originalPickupEarliestDateTime;
  }

  @computed public get originalPickupLatestDateTime(): Date {
    return this.task.originalPickupLatestDateTime;
  }

  @computed public get originalDropoffEarliestDateTime(): Date {
    return this.task.originalDropoffEarliestDateTime;
  }

  @computed public get originalDropoffLatestDateTime(): Date {
    return this.task.originalDropoffLatestDateTime;
  }

  @Input() public height: number = 300;

  @Input() public hideTaskSchedule: boolean = false;

  public taskSupplierScheduleStore: TaskSupplierScheduleStore;

  public dateTimeColumnGroups: DateTimeColumn[][] = [];
  public originalDateTimeColumnGroups: DateTimeColumn[][] = [];

  constructor(private jobService: JobsService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    void this.setup();
  }

  async setup() {
    if (!this.hideTaskSchedule) {
      const scheduleContext = await this.jobService.getUpdateSupplierScheduleContext(
        this.task.jobId,
      );
      this.taskSupplierScheduleStore = new TaskSupplierScheduleStore(scheduleContext.tasks[0], []);
    }

    const isCustomer = this.orgTypeId == OrganisationTypeEnum.Customer;

    this.dateTimeColumnGroups = [
      [
        {
          title: 'Earliest Collection',
          date: isCustomer ? this.originalPickupEarliestDateTime : this.pickupEarliestDateTime,
          type: DateTimeColumnType.PickUp,
          iconClass: 'text-pick-up-colour',
        },
        {
          title: 'Latest Collection',
          date: isCustomer ? this.originalPickupLatestDateTime : this.pickupLatestDateTime,
          type: DateTimeColumnType.PickUp,
          iconClass: 'text-pick-up-colour',
        },
      ],
      [
        {
          title: 'Earliest Delivery',
          date: isCustomer ? this.originalDropoffEarliestDateTime : this.dropoffEarliestDateTime,
          type: DateTimeColumnType.DropOff,
          iconClass: 'text-drop-off-colour',
        },
        {
          title: 'Latest Delivery',
          date: isCustomer ? this.originalDropoffLatestDateTime : this.dropoffLatestDateTime,
          type: DateTimeColumnType.DropOff,
          iconClass: 'text-drop-off-colour',
        },
      ],
    ];

    if (this.task.isRescheduled && this.orgTypeId == OrganisationTypeEnum.Engineius) {
      this.originalDateTimeColumnGroups = [
        [
          {
            title: 'Original Earliest Collection',
            date: this.originalPickupEarliestDateTime,
            type: DateTimeColumnType.PickUp,
            iconClass: 'text-pick-up-colour',
          },
          {
            title: 'Original Latest Collection',
            date: this.originalPickupLatestDateTime,
            type: DateTimeColumnType.PickUp,
            iconClass: 'text-pick-up-colour',
          },
        ],
        [
          {
            title: 'Original Earliest Delivery',
            date: this.originalDropoffEarliestDateTime,
            type: DateTimeColumnType.DropOff,
            iconClass: 'text-drop-off-colour',
          },
          {
            title: 'Original Latest Delivery',
            date: this.originalDropoffLatestDateTime,
            type: DateTimeColumnType.DropOff,
            iconClass: 'text-drop-off-colour',
          },
        ],
      ];
    }
  }
}
